var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewGameAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_add_circle",
    "data-name": " add_circle",
    transform: "translate(0.149 -0.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 44,
    height: 43,
    transform: "translate(-0.149 0.31)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.5,37A18.5,18.5,0,1,1,37,18.5,18.521,18.521,0,0,1,18.5,37ZM11.1,16.65a1.85,1.85,0,0,0,0,3.7h5.549V25.9a1.85,1.85,0,1,0,3.7,0V20.35H25.9a1.85,1.85,0,0,0,0-3.7H20.349V11.1a1.85,1.85,0,0,0-3.7,0V16.65Z",
    transform: "translate(2.851 3.31)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGameAddIcon);
export default __webpack_public_path__ + "static/media/new-game-add-icon.b6e6b8c8569474e2c54a873c5950749c.svg";
export { ForwardRef as ReactComponent };